export const FullScreenLoader = () => {
  return (
    <div className="flex items-center justify-center h-[calc(100vh)]">
      <span className="loading loading-spinner w-20 h-20"></span>
    </div>)
}
